import {Router} from "../../../stem-core/src/ui/Router.jsx";
import {iFrameAuthService} from "../../services/IFrameAuthService.js";
import {INLINE_USER_DASHBOARD_URLS} from "../PanelConstants.js";
import {BaseFlowHandler} from "./BaseFlowHandler.js";
import {PANEL_TYPE} from "../../../blink-sdk/Constants.js";


export class DashboardFlowHandler extends BaseFlowHandler {
    panelType = PANEL_TYPE.dashboard;
    card = null; // TODO @branch @mustfix what are these? Comment or remove.
    entries = null;

    async start() {
        await iFrameAuthService.promptAuthenticationIfNeeded();
        Router.changeURL(INLINE_USER_DASHBOARD_URLS.home);
    }
}
